


































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { numberToHumanSize } from 'bits/numbers_helper'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import OzMembershipTierGrid from 'library/v4/components/OzMembershipTierGrid.vue'
import { User } from 'types'

export enum Variant {
  Upgrade,
  UnderPadletQuota,
  AtPadletQuota,
  OverPadletQuota,
  FileSize,
  SignUp,
  Continue,
}

@Component({ components: { OzBox, OzContainedButton, OzIcon, OzLoadingSpinner, OzMembershipTierGrid } })
export default class GoldMembershipTier extends Vue {
  @Prop() user!: User
  @Prop() fileSize!: number

  /**
   * Defines which variant should be displayed.
   */
  @Prop({ required: true }) variant!: Variant

  /**
   * Determines whether the OzMembershipTierGrid component should be expanded or not.
   */
  @Prop({ required: true }) isExpanded!: boolean

  /**
   * Determines whether the plan information is being loaded or not.
   */
  @Prop({ required: true }) isLoadingPlanInformation!: boolean

  /**
   * The plan's monthly price.
   */
  @Prop({ required: true }) monthlyPrice!: string

  /**
   * The plan's annual price.
   */
  @Prop({ required: true }) annualPrice!: string

  /**
   * Determines whether to show the checkmark next to the tier name or not.
   */
  @Prop({ default: false }) xChecked!: boolean

  /**
   * The maximum amount of walls allowed in this Tier
   */
  @Prop({ required: true }) advertisedWallsQuota!: number

  /**
   * The maximum upload file size allowed in this Tier
   */
  @Prop({ required: true }) advertisedFileSizeQuota!: string

  /**
   * Whether Advertised Quotas have been fetched
   */
  @Prop({ required: true }) isLoadingAdvertisedQuotas!: boolean

  numberToHumanSize = numberToHumanSize
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  Variant = Variant

  get isPadletQuotaOrFileSizeVariant(): boolean {
    return (
      this.variant === Variant.UnderPadletQuota ||
      this.variant === Variant.AtPadletQuota ||
      this.variant === Variant.OverPadletQuota ||
      this.variant === Variant.FileSize
    )
  }

  get colorScheme(): OzBoxColors | null {
    if (this.isPadletQuotaOrFileSizeVariant) return OzBoxColors.Secondary
    if (this.variant === Variant.Upgrade || this.variant === Variant.Continue) return OzBoxColors.Highlight
    return null
  }
}
